module.exports = {
  TOKEN_TEXT: 'token:text',

  TOKEN_OPEN_TAG_START: 'token:open-tag-start',

  TOKEN_ATTRIBUTE_KEY: 'token:attribute-key',
  TOKEN_ATTRIBUTE_ASSIGNMENT: 'token:attribute-assignment',
  TOKEN_ATTRIBUTE_VALUE_WRAPPER_START: 'token:attribute-value-wrapper-start',
  TOKEN_ATTRIBUTE_VALUE: 'token:attribute-value',
  TOKEN_ATTRIBUTE_VALUE_WRAPPER_END: 'token:attribute-value-wrapper-end',

  TOKEN_OPEN_TAG_END: 'token:open-tag-end',
  TOKEN_CLOSE_TAG: 'token:close-tag',

  TOKEN_OPEN_TAG_START_SCRIPT: 'token:open-tag-start-script',
  TOKEN_SCRIPT_TAG_CONTENT: 'token:script-tag-content',
  TOKEN_OPEN_TAG_END_SCRIPT: 'token:open-tag-end-script',
  TOKEN_CLOSE_TAG_SCRIPT: 'token:close-tag-script',

  TOKEN_OPEN_TAG_START_STYLE: 'token:open-tag-start-style',
  TOKEN_STYLE_TAG_CONTENT: 'token:style-tag-content',
  TOKEN_OPEN_TAG_END_STYLE: 'token:open-tag-end-style',
  TOKEN_CLOSE_TAG_STYLE: 'token:close-tag-style',

  TOKEN_DOCTYPE_START: 'token:doctype-start',
  TOKEN_DOCTYPE_END: 'token:doctype-end',
  TOKEN_DOCTYPE_ATTRIBUTE_WRAPPER_START: 'token:doctype-attribute-wrapper-start',
  TOKEN_DOCTYPE_ATTRIBUTE: 'token:doctype-attribute',
  TOKEN_DOCTYPE_ATTRIBUTE_WRAPPER_END: 'token:doctype-attribute-wrapper-end',

  TOKEN_COMMENT_START: 'token:comment-start',
  TOKEN_COMMENT_CONTENT: 'token:comment-content',
  TOKEN_COMMENT_END: 'token:comment-end'
}

